<!-- Overlay loading -->
<div
  *ngIf="isOverlayLoading"
  class="overlay d-flex align-items-center justify-content-center"
>
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>

<div class="d-flex flex-column flex-column-fluid">
  <div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-fluid">
      <div class="row gx-5 gx-xl-10">
        <div class="card mb-5 mb-xl-8">
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label fw-bold fs-3 mb-1">{{
                branchId
                  ? ("editBranch" | translate)
                  : ("createNewBranch" | translate)
              }}</span>
            </h3>
          </div>
          <div class="card-body py-3">
            <form [formGroup]="branchForm" (ngSubmit)="saveBranch($event)">
              <!-- Corporate Informations -->
              <div class="row mb-5 mt-5">
                <!-- Name -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <input
                      formControlName="name"
                      type="text"
                      class="form-control"
                      id="inputName"
                      placeholder="{{ 'name' | translate }}"
                      required
                    />
                    <label for="inputName">{{ "name" | translate }}</label>
                    <div *ngIf="isControlInvalid('name')" class="text-danger">
                      <ng-container
                        *ngIf="branchForm.get('name')?.hasError('required')"
                      >
                        {{ "nameRequired" | translate }}
                      </ng-container>
                      <ng-container
                        *ngIf="
                          !branchForm.get('name')?.hasError('required') &&
                          branchForm.get('name')?.hasError('onlyLetters')
                        "
                      >
                        {{ "nameMustContainOnlyLetters" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
                <!-- Customer Selection -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <ngx-select-dropdown
                      formControlName="customerId"
                      class="custom-select-input"
                      [options]="customerCodes"
                      [instanceId]="'instance1'"
                      [multiple]="false"
                      [config]="customerDropdownConfig"
                    >
                    </ngx-select-dropdown>
                    <div
                      *ngIf="isControlInvalid('customerId')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          branchForm.get('customerId')?.hasError('required')
                        "
                      >
                        {{ "customerSelectionRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>

                <!-- Language Selection -->
                <div class="col-lg-3 col-md-4 col-sm-6 mb-6">
                  <div class="form-floating">
                    <ngx-select-dropdown
                      formControlName="languageCode"
                      class="custom-select-input"
                      [options]="languages"
                      [instanceId]="'instance1'"
                      [multiple]="false"
                      [config]="languageDropdownConfig"
                    >
                    </ngx-select-dropdown>
                    <div
                      *ngIf="isControlInvalid('languageCode')"
                      class="text-danger"
                    >
                      <ng-container
                        *ngIf="
                          branchForm.get('languageCode')?.hasError('required')
                        "
                      >
                        {{ "languageSelectionRequired" | translate }}
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-8 gap-3">
                <button
                  [routerLink]="['/branch/list']"
                  type="button"
                  class="btn btn-sm btn-secondary cursor-pointer"
                >
                  {{ "cancel" | translate }}
                </button>
                <button
                  type="submit"
                  class="btn btn-sm btn-dark cursor-pointer"
                >
                  {{ "save" | translate }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
